import { render, staticRenderFns } from "./home-step.vue?vue&type=template&id=1a4d82e0&scoped=true&lang=pug&"
import script from "./home-step.vue?vue&type=script&lang=coffee&"
export * from "./home-step.vue?vue&type=script&lang=coffee&"
import style0 from "./home-step.vue?vue&type=style&index=0&id=1a4d82e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d82e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NetlifyTooltip: require('/opt/build/repo/components/globals/netlify-tooltip.vue').default,Btn: require('/opt/build/repo/components/globals/btn/btn.vue').default,HomeBtnWithEstimate: require('/opt/build/repo/components/home/btn-with-estimate.vue').default,VueForm: require('/opt/build/repo/node_modules/vue-form/src/components/vue-form.vue').default,StepWrapper: require('/opt/build/repo/components/globals/step-wrapper.vue').default})
